import api from 'lib/trpcClient';
import { useState } from 'react';

export default function useReconcilableTransactions(vehicleId: string) {
  const [selectedTransactionIds, setSelectedTransactionIds] = useState<
    Array<string>
  >([]);

  const [reconcilableTransactions] =
    api.manualJournal.getReconciliableTransactions.useSuspenseQuery({
      vehicleId,
    });

  const handleTransactionSelection = (
    selectedTransactionIds: Array<string>,
  ) => {
    setSelectedTransactionIds(selectedTransactionIds);
  };

  return {
    selectedTransactionIds,
    reconcilableTransactions,
    handleTransactionSelection,
  };
}
